import React, { useCallback } from 'react'
import { Linking, StyleSheet } from 'react-native'
import HyperLink from 'react-native-hyperlink'
import { DefaultTheme } from 'styled-components'

import { useTheme } from 'contexts/ThemeContext'

import { StyledText } from './styled'
import { FontSizes, TextProps } from './types'

import { ConditionalWrapper } from '../ConditionalWrapper'

const makeStyles = (theme: DefaultTheme, fontSize: FontSizes) =>
  StyleSheet.create({
    hyperLink: {
      color: theme.colors.primary,
      fontSize: theme.fonts.sizes[fontSize],
    },
  })

export const Text = ({
  children,
  align = 'left',
  bold = false,
  black = false,
  fontWeight = 'normal',
  fontSize = 'md',
  fontStyle = 'normal',
  color = 'text',
  withLinks = false,
  isCompact = false,
  onLinkLongPress,
  ...rest
}: TextProps) => {
  const theme = useTheme()
  const styles = makeStyles(theme, fontSize)

  const hyperlinkedText = useCallback(
    (wrappedChildren) => {
      return (
        <HyperLink
          linkStyle={styles.hyperLink}
          onPress={(url: string) => Linking.openURL(url)}
          onLongPress={onLinkLongPress}
        >
          {wrappedChildren}
        </HyperLink>
      )
    },
    [onLinkLongPress, styles.hyperLink],
  )

  return (
    <ConditionalWrapper
      condition={withLinks}
      wrapper={(wrappedChildren: React.ReactNode | string) => hyperlinkedText(wrappedChildren)}
    >
      <StyledText
        align={align}
        color={color}
        fontSize={fontSize}
        fontStyle={fontStyle}
        // eslint-disable-next-line no-nested-ternary
        fontWeight={bold ? 'bold' : black ? 'black' : fontWeight}
        isCompact={isCompact}
        {...rest}
      >
        {children}
      </StyledText>
    </ConditionalWrapper>
  )
}
